var exports = {
  "E": "Text__hXY6ps",
};

module.exports = exports;
